import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { ConditionDto, ConditionHistoryDto } from '~/models/modules/conditions';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class ConditionsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }




  getConditionGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }



  getConditionById(id : number){
    return this.http.get<ConditionDto>(this._url(`/${id}`));
  }

  // getConditionListing(model: any = null){
  //   return this.http.get<ConditionDto[]>(this._url());
  // }
  getConditionListing(model: any = {}){
    //return this.http.post<ConditionDto[]>(this._url());
    return this.http.post<ConditionDto[]>(this._url(`/conditionListing`), model);
  }
  createCondition(model : any){
    return this.client.post<ConditionDto>(this._url(), model);
  }
  updateCondition(id: number, model : any){
    return this.client.put<any>(this._url(`/${id}`), model);
  }
  deactivateCondition(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }
  deactivateConditionBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }
  reactivateCondition(id: number) {
    return this.client.put(this._url(`/reactivate/${id}`), null);
  }
  reactivateBatchCondition(obj: any) {
    return this.client.put(this._url(`/batchReactivate`), obj);
  }
  checkIsSystemRelated(id:number){
    return this.client.post<boolean>(this._url(`/is-system`), id);
  }
  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Conditions${v}`);
  }


  getConditionDropdown() {
    return this.http.get<ConditionDto[]>(this._url('/dropdown'));
  }

  getAssetConditionHistory(assetId: number) {
    return this.http.get<ConditionHistoryDto[]>(this._url(`/asset-history/${assetId}`));
  }

  getBlacklistedConditions() {
    return this.http.get<ConditionDto[]>(this.url('/BlacklistConditions'));
  }

  addToBlacklist(id: number) {
    return this.client.post(this.url(`/BlacklistConditions/${id}`), null);
  }

  removeFromBlacklist(id: number) {
    return this.client.delete(this.url(`/BlacklistConditions/${id}`));
  }

}